<script>
  import DataTableArea from "./DataTableArea.svelte";
  import { get_table_data_no_split, to_percentage } from "./Utils.svelte";

  let grey_index_table_2 = [2, 3, 7, 11];

  let data_table_no_data_split = false;
  let finished_create_data_table_split_into_sources = false;
  let finished_create_data_table_split_into_sources_and_campaigns = false;

  let show = false;

  export let flow_numbers_dict;
  export let sources_and_campains_data_table_dict;
  export let sources_and_campains_data_table_dict_countries;
  export let list_of_countries_shorts;

  let data_table_for_countries = {};

  export let list_of_countries;

  $: {
    flow_numbers_dict, sources_and_campains_data_table_dict, sources_and_campains_data_table_dict_countries;

    if (flow_numbers_dict && sources_and_campains_data_table_dict && sources_and_campains_data_table_dict_countries) {
      // console.log("sources_and_campains_data_table_dict: ", sources_and_campains_data_table_dict)
      // console.log("sources_and_campains_data_table_dict_countries: ", sources_and_campains_data_table_dict_countries)

      // console.log("sources_and_campains_data_table_dict: ", sources_and_campains_data_table_dict)

      data_table_no_data_split = get_table_data_no_split(flow_numbers_dict);

      data_table_split_into_sources_and_campaigns["values"] = create_data_table_split_into_sources_and_campaigns(
        sources_and_campains_data_table_dict["begin_values"],
        sources_and_campains_data_table_dict["extra_sums"],
      );

      list_of_countries.forEach(function (country) {
        data_table_for_countries[country] = copy_header_in_every_country_dict(data_table_split_into_sources_and_campaigns);
        data_table_for_countries[country]["values"] = [[]];

        //danach noch die create_data_table_split_into_sources_and_campaigns funktion ausführen
        data_table_for_countries[country]["values"] = create_data_table_split_into_sources_and_campaigns(
          sources_and_campains_data_table_dict_countries[country]["begin_values"],
          sources_and_campains_data_table_dict_countries[country]["extra_sums"],
        );
      });

      create_data_table_split_into_sources(flow_numbers_dict);

      finished_create_data_table_split_into_sources = true;
      finished_create_data_table_split_into_sources_and_campaigns = true;
    }
  }

  function copy_header_in_every_country_dict(data_table_split_into_sources_and_campaigns) {
    return JSON.parse(JSON.stringify(data_table_split_into_sources_and_campaigns));
  }

  // let data_table_no_data_split = {
  //   columns: [
  //     {
  //       value: '',
  //       border_col_top: '#FFFFFF',
  //       border_col_sides: false,
  //       background_color: '#FFFFFF',
  //       extra_class: 'width: 30%',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: '% of New Leads',
  //       border_col_top: '#40c4f4',
  //       border_col_sides: '#40c4f4',
  //       background_color: '#FFFFFF',
  //       extra_class: '',
  //       text_color: '#40c4f4',
  //     },
  //     {
  //       value: 'New LEADS',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#d6dce4',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: 'New OPP',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#d6dce4',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: 'Open Leads',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#FFFFFF',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: 'Archived Leads',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#FFFFFF',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: 'Lost Leads',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#FFFFFF',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: 'New CUST',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#d6dce4',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: 'Open OPPs',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#FFFFFF',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: 'Archived OPPs',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#FFFFFF',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: 'Lost OPPs',
  //       border_col_top: '#96a0ad',
  //       border_col_sides: false,
  //       background_color: '#FFFFFF',
  //       extra_class: '',
  //       text_color: '#262626',
  //     },
  //     {
  //       value: '% of New CUST',
  //       border_col_top: '#40c4f4',
  //       border_col_sides: '#40c4f4',
  //       background_color: '#FFFFFF',
  //       extra_class: '',
  //       text_color: '#40c4f4',
  //     },
  //   ],
  //   values: [
  //     [
  //       {
  //         value: 'Total',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: 'width: 30%',
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '100%',
  //         border_col_top: '#44546a',
  //         border_col_sides: '#40c4f4',
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#40c4f4',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '1000',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '250',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '500',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '50',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '200',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '20',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '150',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '20',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '60',
  //         border_col_top: '#44546a',
  //         border_col_sides: false,
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#262626',
  //         border_bottom: '#44546a',
  //       },
  //       {
  //         value: '100%',
  //         border_col_top: '#44546a',
  //         border_col_sides: '#40c4f4',
  //         background_color: '#d6dce4',
  //         extra_class: false,
  //         text_color: '#40c4f4',
  //         border_bottom: '#44546a',
  //       },
  //     ],
  //   ],
  // };

  let data_table_split_into_sources = {
    columns: [
      {
        value: "",
        border_col_top: "#FFFFFF",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "width: 30%",
        text_color: "#262626",
      },
      {
        value: "% of New Leads",
        border_col_top: "#40c4f4",
        border_col_sides: "#40c4f4",
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#40c4f4",
      },
      {
        value: "New LEADS",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#d6dce4",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "New OPP",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#d6dce4",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Open Leads",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Archived Leads",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Lost Leads",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "New CUST",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#d6dce4",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Open OPPs",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Archived OPPs",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Lost OPPs",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Sold BOLUSES",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#d6dce4",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "% of New CUST",
        border_col_top: "#40c4f4",
        border_col_sides: "#40c4f4",
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#40c4f4",
      },
    ],
    values: [[]],
  };

  let data_table_split_into_sources_and_campaigns = {
    columns: [
      {
        value: "SC/Source",
        border_col_top: "#FFFFFF",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "width: 30%",
        text_color: "#262626",
      },
      {
        value: "Campaign",
        border_col_top: "#FFFFFF",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "width: 30%",
        text_color: "#262626",
      },
      {
        value: "% of New Leads",
        border_col_top: "#40c4f4",
        border_col_sides: "#40c4f4",
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#40c4f4",
      },
      {
        value: "New LEADS",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#d6dce4",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "New OPP",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#d6dce4",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Open Leads",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Archived Leads",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Lost Leads",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "New CUST",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#d6dce4",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Open OPPs",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Archived OPPs",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Lost OPPs",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "Sold BOLUSES",
        border_col_top: "#96a0ad",
        border_col_sides: false,
        background_color: "#d6dce4",
        extra_class: "",
        text_color: "#262626",
      },
      {
        value: "% of New CUST",
        border_col_top: "#40c4f4",
        border_col_sides: "#40c4f4",
        background_color: "#FFFFFF",
        extra_class: "",
        text_color: "#40c4f4",
      },
    ],
    values: [[]],
  };

  function create_data_table_split_into_sources_and_campaigns(sources_and_campains_data_table_dict, extra_sums) {
    let ret = [];

    for (const [source_category, sc_value] of Object.entries(sources_and_campains_data_table_dict).sort()) {
      for (const [source, source_value] of Object.entries(sc_value).sort(function (first, second) {
        if (first[0] == "Total") {
          return 1;
        }

        if (second[0] == "Total") {
          return -1;
        }

        if (first[1]["Total"]["New_LEADS"] > second[1]["Total"]["New_LEADS"]) {
          return -1;
        }
        if (first[1]["Total"]["New_LEADS"] < second[1]["Total"]["New_LEADS"]) {
          return 1;
        }
        return 0;
      })) {
        ret.push(get_default_line([source_category, "", "", "", "", "", "", "", "", "", "", "", "", ""], 1, true));
        ret.push(get_default_line(["<b>&nbsp; &nbsp;" + source + "</b>", "", "", "", "", "", "", "", "", "", "", "", "", ""], 1, true));

        let index = 0;

        for (const [campaign, leads_per_campaign_list_dict] of Object.entries(source_value).sort(function (first, second) {
          if (first[0] == "Total") {
            return 1;
          }

          if (second[0] == "Total") {
            return -1;
          }

          if (first[1]["matrix"][3] > second[1]["matrix"][3]) {
            return -1;
          }
          if (first[1]["matrix"][3] < second[1]["matrix"][3]) {
            return 1;
          }
          return 0;
        })) {
          let matrix = leads_per_campaign_list_dict["matrix"];

          // console.log("matrix: ", matrix)

          var table_row = get_default_line(matrix, 1);
          // console.log("default line: ", table_row)
          // console.log("Endgültige Row: ", table_row)

          if (index % 2 == 0) {
            table_row = format_abwechselnd_eins(table_row, 1);
          }
          if (index % 2 == 1) {
            table_row = format_abwechselnd_zwei(table_row);
          }

          if (campaign == "Total") {
            table_row = format_last_row(table_row);
          }

          ret.push(table_row);
          index += 1;
        }
      }
      //Irgendwas dazwischen einfügen:
      if (Object.entries(sc_value).length > 0) {
        ret.push(format_total_sc_row(get_default_line(extra_sums[source_category], 1)));
        ret.push(format_white_row(get_default_line(["&nbsp;", "&nbsp;", "&nbsp;", "", "", "", "", "", "", "", "", "", "", ""], 1)));
      }
    }

    ret.push(format_white_row(get_default_line(["&nbsp;", "&nbsp;", "&nbsp;", "", "", "", "", "", "", "", "", "", "", ""], 1)));
    ret.push(format_last_sum_row(get_default_line(extra_sums["Total"], 1)));

    return ret;
  }

  function create_data_table_split_into_sources(flow_numbers_dict) {
    let ret = [];
    let index = 0;
    let split_into_sources_data = [
      [
        "ADV (Advertising)",
        to_percentage(flow_numbers_dict["ADV"], flow_numbers_dict["New_LEADS"]),
        flow_numbers_dict["ADV"],
        flow_numbers_dict["ADV_New_OPP"],
        flow_numbers_dict["ADV_Open_Leads"],
        flow_numbers_dict["ADV_Archived_Leads"],
        flow_numbers_dict["ADV_Lost_Leads"],
        flow_numbers_dict["ADV_New_Customer"],
        flow_numbers_dict["ADV_New_OPP_Open"],
        flow_numbers_dict["ADV_New_OPP_Archived"],
        flow_numbers_dict["ADV_New_OPP_Lost"],
        flow_numbers_dict["ADV_New_Boli"],
        to_percentage(flow_numbers_dict["ADV_New_Customer"], flow_numbers_dict["New_CUST"]),
      ],
      [
        "EVT (Events)",
        to_percentage(flow_numbers_dict["EVT"], flow_numbers_dict["New_LEADS"]),
        flow_numbers_dict["EVT"],
        flow_numbers_dict["EVT_New_OPP"],
        flow_numbers_dict["EVT_Open_Leads"],
        flow_numbers_dict["EVT_Archived_Leads"],
        flow_numbers_dict["EVT_Lost_Leads"],
        flow_numbers_dict["EVT_New_Customer"],
        flow_numbers_dict["EVT_New_OPP_Open"],
        flow_numbers_dict["EVT_New_OPP_Archived"],
        flow_numbers_dict["EVT_New_OPP_Lost"],
        flow_numbers_dict["EVT_New_Boli"],
        to_percentage(flow_numbers_dict["EVT_New_Customer"], flow_numbers_dict["New_CUST"]),
      ],
      [
        "ORG (Organic)",
        to_percentage(flow_numbers_dict["ORG"], flow_numbers_dict["New_LEADS"]),
        flow_numbers_dict["ORG"],
        flow_numbers_dict["ORG_New_OPP"],
        flow_numbers_dict["ORG_Open_Leads"],
        flow_numbers_dict["ORG_Archived_Leads"],
        flow_numbers_dict["ORG_Lost_Leads"],
        flow_numbers_dict["ORG_New_Customer"],
        flow_numbers_dict["ORG_New_OPP_Open"],
        flow_numbers_dict["ORG_New_OPP_Archived"],
        flow_numbers_dict["ORG_New_OPP_Lost"],
        flow_numbers_dict["ORG_New_Boli"],
        to_percentage(flow_numbers_dict["ORG_New_Customer"], flow_numbers_dict["New_CUST"]),
      ],
      [
        "SAL (Sales)",
        to_percentage(flow_numbers_dict["SAL"], flow_numbers_dict["New_LEADS"]),
        flow_numbers_dict["SAL"],
        flow_numbers_dict["SAL_New_OPP"],
        flow_numbers_dict["SAL_Open_Leads"],
        flow_numbers_dict["SAL_Archived_Leads"],
        flow_numbers_dict["SAL_Lost_Leads"],
        flow_numbers_dict["SAL_New_Customer"],
        flow_numbers_dict["SAL_New_OPP_Open"],
        flow_numbers_dict["SAL_New_OPP_Archived"],
        flow_numbers_dict["SAL_New_OPP_Lost"],
        flow_numbers_dict["SAL_New_Boli"],
        to_percentage(flow_numbers_dict["SAL_New_Customer"], flow_numbers_dict["New_CUST"]),
      ],
      [
        "Total",
        "100%",
        flow_numbers_dict["New_LEADS"],
        flow_numbers_dict["New_OPP"],
        flow_numbers_dict["Open_Leads"],
        flow_numbers_dict["Archived_Leads"],
        flow_numbers_dict["Lost_Leads"],
        flow_numbers_dict["New_CUST"],
        flow_numbers_dict["Open"],
        flow_numbers_dict["Archived"],
        flow_numbers_dict["Lost"],
        flow_numbers_dict["ADV_New_Boli"] +
          flow_numbers_dict["EVT_New_Boli"] +
          flow_numbers_dict["ORG_New_Boli"] +
          flow_numbers_dict["SAL_New_Boli"],
        "100%",
      ],
    ];
    split_into_sources_data.forEach(function (row) {
      var table_row = get_default_line(row);
      // console.log("default line: ", table_row)

      if (index % 2 == 0) {
        table_row = format_abwechselnd_eins(table_row);
      }
      if (index % 2 == 1) {
        table_row = format_abwechselnd_zwei(table_row);
      }

      if (index == 0) {
        table_row = format_first_row(table_row);
      }
      if (index == split_into_sources_data.length - 1) {
        table_row = format_last_row(table_row);
      }
      // console.log("Endgültige Row: ", table_row)
      ret.push(table_row);
      index += 1;
    });

    data_table_split_into_sources["values"] = ret;
  }

  function format_abwechselnd_eins(table_row, new_leads_index_offset = 0) {
    // console.log('table_row: ', table_row);
    var index = 0;
    for (; index < table_row.length; index += 1) {
      if (!grey_index_table_2.includes(index - new_leads_index_offset)) {
        table_row[index]["background_color"] = "#f2f2f2";
      }
    }

    return table_row;
  }
  function format_abwechselnd_zwei(table_row) {
    // console.log("table_row: ", table_row)
    var index = 0;
    for (; index < table_row.length; index += 1) {
      table_row[index]["background_color"] = "#ffffff";
    }

    return table_row;
  }
  function format_first_row(table_row) {
    // console.log("table_row: ", table_row)
    var index = 0;
    for (; index < table_row.length; index += 1) {
      table_row[index]["border_col_top"] = "#44546a";
    }

    return table_row;
  }

  function format_white_row(table_row) {
    var index = 0;
    for (; index < table_row.length; index += 1) {
      table_row[index]["background_color"] = "#ffffff";
      table_row[index]["border_col_top"] = "#44546a";
      table_row[index]["border_bottom"] = "#44546a";
      table_row[index]["text_color"] = "#FFFFFF";
      table_row[index]["font_weight"] = 700;
      if (index == 0) {
        table_row[index]["text_align"] = "center";
      }
    }

    return table_row;
  }

  function format_last_sum_row(table_row) {
    // console.log("table_row: ", table_row)
    var index = 0;
    for (; index < table_row.length; index += 1) {
      table_row[index]["background_color"] = "#d6dce4";
      table_row[index]["border_col_top"] = "#44546a";
      table_row[index]["border_bottom"] = "#44546a";
      table_row[index]["font_weight"] = 700;
      table_row[index]["text_color"] = "#000000";
      if (index == 0) {
        table_row[index]["colspan"] = 2;
      }
      if (index == 1) {
        table_row[index]["border_col_sides"] = "#40c4f4";
        table_row[index]["text_align"] = "right";
        table_row[index]["text_color"] = "#40c4f4";
      }
      if (index == 2) {
        table_row[index]["border_col_sides"] = false;
      }
    }

    return table_row;
  }

  function format_total_sc_row(table_row) {
    var index = 0;
    for (; index < table_row.length; index += 1) {
      table_row[index]["background_color"] = "#8497b0";
      table_row[index]["border_col_top"] = "#44546a";
      table_row[index]["border_bottom"] = "#44546a";
      table_row[index]["text_color"] = "#FFFFFF";
      table_row[index]["font_weight"] = 700;
      if (index == 0) {
        table_row[index]["text_align"] = "center";
        table_row[index]["colspan"] = 2;
        table_row[index]["border_col_sides"] = false;
      }
      if (index == 1) {
        table_row[index]["border_col_sides"] = false;
        table_row[index]["text_align"] = "right";
        table_row[index]["border_col_sides"] = "#40c4f4";
      }
      if (index == 2) {
        table_row[index]["border_col_sides"] = false;
      }
    }

    return table_row;
  }

  function format_last_row(table_row) {
    // console.log("table_row: ", table_row)
    var index = 0;
    for (; index < table_row.length; index += 1) {
      table_row[index]["background_color"] = "#d6dce4";
      table_row[index]["border_col_top"] = "#44546a";
      table_row[index]["border_bottom"] = "#44546a";
    }

    return table_row;
  }

  function get_default_line(values, new_leads_index_offset = 0, blank = false) {
    let ret = [];

    let index = 0;

    values.forEach(function (value) {
      if (index == 0) {
        ret.push({
          value: value,
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#FFFFFF",
          extra_class: "width: 30%",
          text_color: "#262626",
          font_weight: 400,
        });
      } else {
        if (index == values.length - 1 || index - new_leads_index_offset == 1) {
          ret.push({
            value: value,
            border_col_top: "#96a0ad",
            border_col_sides: "#40c4f4",
            background_color: !blank ? "#d6dce4" : "#FFFFFF",
            extra_class: "",
            text_color: "#40c4f4",
            font_weight: 400,
          });
        } else {
          if (grey_index_table_2.includes(index - new_leads_index_offset)) {
            ret.push({
              value: value,
              border_col_top: "#96a0ad",
              border_col_sides: false,
              background_color: !blank ? "#d6dce4" : "#FFFFFF",
              extra_class: "",
              text_color: "#262626",
              font_weight: 400,
            });
          } else {
            ret.push({
              value: value,
              border_col_top: "#96a0ad",
              border_col_sides: false,
              background_color: "#FFFFFF",
              extra_class: "",
              text_color: "#262626",
              font_weight: 400,
            });
          }
        }
      }
      index = index + 1;
    });

    return ret;
  }

  //Wichitge design infos um es generisch zu machen:
  /*
	schriftfarbe, hintergrundfarbe, rahmendrüber


	*/

  function click_title() {
    show = !show;
  }
</script>

<div on:click={click_title} class="maus">
  <b>
    {#if !show}
      ▼
    {:else}
      ▲
    {/if}
    Datatables
  </b>
</div>
<div class="div {show ? 'shownClass' : 'hiddenClass'}">
  <div style="margin: 20px;">
    {#if data_table_no_data_split}
      <DataTableArea data={data_table_no_data_split} how_many_first_columns_left_align={1} nr={1} title="No data split" show={false} />
    {/if}
    {#if finished_create_data_table_split_into_sources}
      <DataTableArea
        data={data_table_split_into_sources}
        how_many_first_columns_left_align={1}
        nr={2}
        title="Data split into source categories"
        show={false}
      />
    {/if}
    {#if data_table_split_into_sources_and_campaigns && finished_create_data_table_split_into_sources_and_campaigns}
      <DataTableArea
        data={data_table_split_into_sources_and_campaigns}
        how_many_first_columns_left_align={2}
        nr={3}
        title="Data split into source categories, sources, and campaigns"
        show={false}
      />

      {#each list_of_countries as country, index}
        <DataTableArea
          data={data_table_for_countries[country]}
          nr={4 + index}
          how_many_first_columns_left_align={2}
          title="Data split into source categories, sources and campaigns - Lead country: {list_of_countries_shorts[index]}"
          show={false}
        />
      {/each}
    {/if}
  </div>
</div>

{#if !show}
  <div style="width: 100%; height: 30px;" />
{/if}

<style>
  .maus:hover {
    cursor: pointer;
  }

  .hiddenClass {
    /*visibility: hidden;
    display: none;
    opacity:  0;
    transition: visibility 2s, opacity 2s linear;*/

    max-height: 0;
    opacity: 0;
    transition: opacity 0.5s ease-out;
    transition: max-height 0.5s ease-in;
  }

  .shownClass {
    max-height: auto;

    opacity: 1;
    transition: max-height 0.5s ease-in;
    transition: opacity 0.5s ease-in;
  }
</style>
